const scaling = {
  'groundSurface': {
    'unit': 'ha',
    'min': 0,
    'max': 100,
    'step': 0.5,
    'default': 0
  },
  'flatRoofSurface': {
    'unit': 'm2',
    'min': 500,
    'max': 50000,
    'step': 1,
    'default': 0
  },
  'gableRoofSurface': {
    'unit': 'm2',
    'min': 500,
    'max': 50000,
    'step': 1,
    'default': 0
  },
  'monoPitchedRoofSurface': {
    'unit': 'm2',
    'min': 500,
    'max': 50000,
    'step': 1,
    'default': 0
  },
  'yearlyEnergyUsage': {
    'unit': 'kWh',
    'min': 25000,
    'max': 999999,
    'step': 10,
    'default': 5
  },
  'dayPrice': {
    'unit': '&euro; Euro',
    'min': 0.00,
    'max': 100,
    'step': 0.01,
    'default': 0.04
  },
  'nightPrice': {
    'unit': '&euro; Euro',
    'min': 0.00,
    'max': 100,
    'step': 0.01,
    'default': 0.05
  }
}

export default scaling



// WEBPACK FOOTER //
// ./src/stores/scaling.js